import React, { useState, useEffect, Fragment, useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  Grid,
  Paper,
  Button,
  TextField,
  FormControl,
  Typography,
  MenuItem,
  IconButton,
  Tooltip,
  Chip,
  Collapse,
  Backdrop,
  CircularProgress,
  InputBase,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import EmailIcon from "@material-ui/icons/Email";
import AddIcon from "@material-ui/icons/Add";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import FileCopyIcon from "@material-ui/icons/FileCopy";

import notify from "../utils/notifier";
import AdminDashboardService from "../services/AdminDashboardService";

const useStyles = makeStyles(theme => ({
  borderMain: {
    marginLeft: "-10px",
    marginRight: "-10px",
    marginTop: "-1px",
  },
  tableTitleDiv: {
    display: "flex",
    paddingLeft: "15px",
    paddingRight: "15px",
    marginLeft: "12.8px",
    flexDirection: 'row',
    fontFamily: 'Times New Roman'
  },
  tableTitleDiv2: {
    display: "flex",
    paddingLeft: "15px",
    paddingRight: "15px",
    marginLeft: "12.8px",
    marginRight: "12.8px",
    flexDirection: 'row',
    fontFamily: 'Times New Roman',
  },
  tableTitle: {
    display: "flex",
  },
  root: {
    width: "100%",
    background: "white",
    paddingBottom: "16px",
  },
  submitFilterButton: {
    marginRight: "1rem",
    float: "right",
  },
  box: {
    display: "block",
    borderTop: "5px solid #173a64",
    padding: "20px 20px 15px 10px",
    marginLeft: '15px',
    marginRight: '15px',
    marginBottom: '3rem',
    wordBreak: "break-all",
  },
  tableProp: {
    background: "#f8f8f8",
  },
  tableHeadRow: {
    fontWeight: "700"
  },
  horizontalLine: {
    height: "4px",
    border: "none",
    boxShadow: "none",
    backgroundColor: "#36454F",
    marginBottom: "20px"
  },
  transactionListDiv: {
    display: "block",
    borderTop: "5px solid #173a64",
    padding: "20px 20px 60px 10px",
    marginLeft: '15px',
    marginRight: '15px',
    marginBottom: '1.5rem',
    wordBreak: "break-all",
  },
  tableWrapper: {
    width: "100%",
    maxHeight: "70vh",
    overflow: "auto",
    fontFamily: "courier"
  },
  tableContainer: {
    padding: "20px",
    paddingTop: "0px"
  },
  tableBorder: {
    border: "0.8px solid #00000021"
  },
  tableColumnLabel: {
    width: "100%",
    justifyContent: "center"
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1
  },
  noRecordsRow: {
    background: "#f8f8f8"
  },
  searchBox: {
    display: 'flex',
    height: "40px",
    marginRight: "20px",
    alignItems: "center",
    marginBottom: "20px"
  },
  searchInput: {
    marginLeft: "8px",
    flex: 1
  },
  // Table cell styles
  tableCell: {
    padding: "16px 8px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  tableCellDescription: {
    padding: "16px 8px",
    whiteSpace: "normal", 
    wordBreak: "break-word",
    wordWrap: "break-word",
    overflowWrap: "break-word"
  },
  tableCellStatus: {
    padding: "16px 8px",
    whiteSpace: "nowrap",
    textAlign: "left"
  },
  tableCellActions: {
    padding: "16px 8px",
    whiteSpace: "nowrap"
  },
  tableCellUser: {
    padding: "16px 8px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center"
  },
  // Form styles
  formContainer: {
    padding: "20px",
    margin: "16px 0",
    backgroundColor: "#f8f8f8",
    borderRadius: "4px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
  },
  formTopRow: {
    display: "flex",
    gap: "24px",
    marginBottom: "20px",
    alignItems: "flex-start"
  },
  formLeftColumn: {
    flex: "1 1 45%",
    minWidth: "300px"
  },
  formRightColumn: {
    flex: "1 1 45%",
    minWidth: "300px"
  },
  formButtonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    marginTop: "8px",
    paddingTop: "8px"
  },
  formField: {
    marginBottom: "16px"
  },
  formFieldDescription: {
    marginTop: "0px",
    marginBottom: "16px",
    minHeight: '140px'
  },
  formFieldEmail: {
    marginTop: "0px",
    marginBottom: "16px"
  },
  formHeader: {
    marginTop: "-10px",
    marginLeft: "0px",
    paddingLeft: "0px"
  },
  // Search styles
  searchContainer: {
    display: "flex", 
    justifyContent: "flex-end", 
    marginTop: "-10px",
    marginBottom: "10px",
    paddingRight: "0px"
  },
  tableWrapperContainer: {
    marginTop: "-15px"
  },
  // Modal styles
  modalTitle: {
    display: "flex", 
    justifyContent: "space-between", 
    alignItems: "center" 
  },
  modalClientName: {
    fontSize: "1.2em", 
    color: "#0d47a1", 
    fontWeight: "700",
    textShadow: "0 1px 1px rgba(0,0,0,0.1)"
  },
  modalContent: {
    marginTop: "16px"
  },
  modalEmailContainer: {
    padding: "16px",
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
    minHeight: "50px"
  },
  modalEmailText: {
    fontFamily: "monospace",
    fontSize: "1rem",
    color: "#333",
    padding: "4px 0",
    borderBottom: "1px solid #e0e0e0"
  },
  modalEmailTextLast: {
    fontFamily: "monospace",
    fontSize: "1rem",
    color: "#333",
    padding: "4px 0",
    borderBottom: "none"
  },
  modalNoData: {
    textAlign: "center", 
    padding: "40px 20px",
    color: "#666"
  },
  modalApiKeyContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px",
    backgroundColor: "#f9f9f9",
    borderRadius: "8px",
    marginBottom: "8px",
    border: "1px solid #e0e0e0",
  },
  modalApiKeyText: {
    fontFamily: "monospace",
    fontSize: "0.9rem",
    marginBottom: "4px",
  },
  modalApiKeyInfo: {
    color: "#666", 
    display: "block"
  },
  modalApiKeyActions: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  // Error styles
  errorContainer: {
    color: "#f44336",
    fontSize: "14px",
    marginTop: "12px",
    padding: "8px",
    backgroundColor: "#ffebee",
    borderRadius: "4px",
    border: "1px solid #ffcdd2"
  },
  // Table header styles
  tableHeaderCell: {
    whiteSpace: "nowrap",
    textAlign: "center",
    padding: "16px 8px"
  },
  tableHeaderCellLeft: {
    whiteSpace: "nowrap",
    textAlign: "left",
    padding: "16px 8px"
  },
  tableSortLabel: {
    width: "100%",
    justifyContent: "center"
  },
  tableSortLabelLeft: {
    width: "100%",
    justifyContent: "flex-start"
  },
  tableHeaderText: {
    width: "100%",
    textAlign: "center"
  },
  tableHeaderTextLeft: {
    width: "100%",
    textAlign: "left"
  },
  tableHeaderTextShifted: {
    width: "100%",
    textAlign: "center",
    paddingLeft: "15px"
  },
  // Table row styles
  tableRow: {
    height: "60px"
  },
  // Grid styles
  gridItem: {
    minHeight: "87vh"
  }
}));

const TABLE_COLUMNS = [
  { id: "clientName", label: "Client Name", width: "150px", sortable: true },
  { id: "clientId", label: "Client ID", width: "120px", sortable: false },
  {
    id: "clientDescription",
    label: "Description",
    width: "200px",
    sortable: false,
  },
  {
    id: "isActiveStatus",
    label: "Status",
    width: "80px",
    sortable: true,
  },
  { id: "createdDate", label: "Created At", width: "120px", sortable: true },
  { id: "updatedDate", label: "Updated At", width: "120px", sortable: true },
  { id: "createdBy", label: "Created By", width: "100px", sortable: true },
  { id: "updatedBy", label: "Updated By", width: "100px", sortable: true },
  { id: "actions", label: "Actions", width: "120px", sortable: false },
];

const RESPONSE_COLUMNS = [
  { id: "property", label: "Property", width: "30%" },
  { id: "value", label: "Value", width: "70%" },
];

const USER_PREFERENCES = {
  rowsPerPageOptions: [10, 20, 50],
};

/**
 * Initial form state for client creation
 */
const INITIAL_FORM_STATE = {
  clientName: { value: "" },
  clientDescription: { value: "" },
  clientEmails: { value: "" },
};
/**
 * Converts technical error messages to user-friendly messages
 * 
 * @param {Error} error - The error object
 * @returns {string} User-friendly error message
 */
const getUserFriendlyErrorMessage = (error) => {
  // Default user-friendly messages
  const defaultMessages = {
    network: "Unable to connect to the server. Please check your internet connection and try again.",
    server: "The server is currently unavailable. Please try again later.",
    validation: "The information you entered is not valid. Please check your inputs and try again.",
    permission: "You don't have permission to perform this action. Please contact your administrator.",
    notFound: "The requested resource was not found.",
    timeout: "The request took too long to complete. Please try again.",
    general: "Something went wrong. Please try again later."
  };

  if (!error) return defaultMessages.general;

  // Handle network errors
  if (!error.response) {
    return defaultMessages.network;
  }

  const { status, data } = error.response;

  // Handle specific HTTP status codes
  switch (status) {
    case 400:
      return "Invalid request. Please check your input and try again.";
    case 401:
      return "Your session has expired. Please log in again.";
    case 403:
      return defaultMessages.permission;
    case 404:
      return defaultMessages.notFound;
    case 408:
      return defaultMessages.timeout;
    case 409:
      return "This action conflicts with existing data. Please refresh and try again.";
    case 422:
      return defaultMessages.validation;
    case 429:
      return "Too many requests. Please wait a moment before trying again.";
    case 500:
    case 502:
    case 503:
    case 504:
      return defaultMessages.server;
    default:
      // Handle specific error codes from backend
      if (data && data.errorCode) {
        switch (data.errorCode) {
          case "40910":
            return "A client with this name already exists. Please choose a different name.";
          case "40001":
            return "Invalid email format. Please check your email addresses.";
          case "40002":
            return "Client name contains invalid characters. Please use only letters, numbers, spaces, hyphens, underscores, and dots.";
          default:
            return defaultMessages.general;
        }
      }
      return defaultMessages.general;
  }
};

/**
 * Validates a single email address format
 * 
 * @param {string} email - Email address to validate
 * @returns {boolean} True if email is valid
 */
const validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  return emailRegex.test(email.trim());
};

/**
 * Validates multiple email addresses separated by commas
 * 
 * @param {string} emailString - Comma-separated email addresses
 * @returns {Object} Validation result with isValid flag and invalidEmails array
 */
const validateEmails = (emailString) => {
  if (!emailString.trim()) {
    return { isValid: true, invalidEmails: [] };
  }

  const emails = emailString
    .split(",")
    .map((email) => email.trim())
    .filter((email) => email !== "");
  const invalidEmails = emails.filter((email) => !validateEmail(email));

  return {
    isValid: invalidEmails.length === 0,
    invalidEmails: invalidEmails,
  };
};

/**
 * Validates client name format and length
 * 
 * @param {string} name - Client name to validate
 * @returns {Object} Validation result with isValid flag and error message
 */
const validateClientName = (name) => {
  if (!name.trim()) {
    return { isValid: false, error: "Client name is required" };
  }
  if (name.trim().length < 1) {
    return { isValid: false, error: "Client name must be at least 1 character" };
  }
  if (name.trim().length > 100) {
    return { isValid: false, error: "Client name must be less than 100 characters" };
  }
  if (!/^[a-zA-Z0-9\s\-_\.]+$/.test(name.trim())) {
    return { isValid: false, error: "Client name can only contain letters, numbers, spaces, hyphens, underscores, and dots" };
  }
  return { isValid: true, error: "" };
};

/**
 * Validates client description format and length
 * 
 * @param {string} description - Client description to validate
 * @returns {Object} Validation result with isValid flag and error message
 */
const validateDescription = (description) => {
  if (!description.trim()) {
    return { isValid: false, error: "Description is required" };
  }
  if (description.trim().length < 1) {
    return { isValid: false, error: "Description must be at least 1 character" };
  }
  if (description.trim().length > 500) {
    return { isValid: false, error: "Description must be less than 500 characters" };
  }
  return { isValid: true, error: "" };
};

/**
 * Gets the active API key from an array of API keys
 * 
 * @param {Array} clientApiKeyArray - Array of API key objects
 * @returns {string|null} Active API key or null if not found
 */
const getActiveApiKey = (clientApiKeyArray) => {
  if (!Array.isArray(clientApiKeyArray) || clientApiKeyArray.length === 0) {
    return null;
  }

  const activeApiKey = clientApiKeyArray.find(
    (keyObj) => keyObj.isActive === true
  );
  return activeApiKey ? activeApiKey.apiKey : null;
};

/**
 * Formats API key for display purposes
 * 
 * @param {Array} clientApiKeyArray - Array of API key objects
 * @returns {string} Formatted API key display string
 */
const formatApiKeyDisplay = (clientApiKeyArray) => {
  const activeApiKey = getActiveApiKey(clientApiKeyArray);
  if (activeApiKey) {
    return activeApiKey;
  }

  if (Array.isArray(clientApiKeyArray) && clientApiKeyArray.length > 0) {
    return "No active API key found";
  }

  return "API Key not available";
};

/**
 * Formats date string to a readable format
 * 
 * @param {string} dateString - Date string to format
 * @returns {string} Formatted date string
 */
const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  try {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
  } catch (error) {
    return "N/A";
  }
};

/**
 * Custom hook for managing form state and validation
 * 
 * @returns {Object} Form state and management functions
 */
const useFormState = () => {
  const [formData, setFormData] = useState(INITIAL_FORM_STATE);
  const [emailError, setEmailError] = useState("");
  const [nameError, setNameError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const updateField = useCallback(
    (field, value) => {
      setFormData((prev) => ({
        ...prev,
        [field]: { value },
      }));

      if (field === "clientEmails") {
        const validation = validateEmails(value);
        if (!validation.isValid) {
          setEmailError(
            `Invalid email(s): ${validation.invalidEmails.join(", ")}`
          );
        } else {
          setEmailError("");
        }
      }

      if (field === "clientName") {
        const validation = validateClientName(value);
        if (!validation.isValid) {
          setNameError(validation.error);
        } else {
          setNameError("");
        }
      }

      if (field === "clientDescription") {
        const validation = validateDescription(value);
        if (!validation.isValid) {
          setDescriptionError(validation.error);
        } else {
          setDescriptionError("");
        }
      }

      if (error) {
        setError(false);
        setErrorMessage("");
      }
    },
    [error]
  );

  const clearForm = useCallback(() => {
    setFormData(INITIAL_FORM_STATE);
    setEmailError("");
    setNameError("");
    setDescriptionError("");
    setError(false);
    setErrorMessage("");
  }, []);

  const setErrors = useCallback((hasError, message) => {
    setError(hasError);
    setErrorMessage(message);
  }, []);

  return {
    formData,
    emailError,
    nameError,
    descriptionError,
    error,
    errorMessage,
    updateField,
    clearForm,
    setErrors,
    setEmailError,
  };
};

/**
 * Custom hook for managing table state, sorting, and pagination
 * 
 * @returns {Object} Table state and management functions
 */
const useTableState = () => {
  const [rows, setRows] = useState([]);
  const [orderBy, setOrderBy] = useState("clientName");
  const [order, setOrder] = useState("asc");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchKey, setSearchKey] = useState({ value: "" });
  const [originalRows, setOriginalRows] = useState([]);

  const sortedRows = useMemo(() => {
    let filteredRows = rows;
    
    // Apply search filter
    if (searchKey.value.trim()) {
      filteredRows = rows.filter(row => 
        row.clientName && 
        row.clientName.toLowerCase().includes(searchKey.value.toLowerCase())
      );
    }
    
    return [...filteredRows].sort((a, b) => {
      let aValue = a[orderBy];
      let bValue = b[orderBy];

      if (orderBy === "isActiveStatus") {
        // Get the most recent API key for status sorting
        const getLatestApiKeyStatus = (clientApiKeyArray) => {
          if (!Array.isArray(clientApiKeyArray) || clientApiKeyArray.length === 0) {
            return false;
          }
          
          // Sort by createdAt to get the most recent
          const sortedKeys = [...clientApiKeyArray].sort((a, b) => {
            const dateA = new Date(a.createdAt || 0);
            const dateB = new Date(b.createdAt || 0);
            return dateB - dateA;
          });
          
          return sortedKeys[0].isActive || false;
        };
        
        aValue = getLatestApiKeyStatus(a.clientApiKey);
        bValue = getLatestApiKeyStatus(b.clientApiKey);
      }

      // Handle sorting for Created By and Updated By columns
      if (orderBy === "createdBy" || orderBy === "updatedBy") {
        aValue = a[orderBy] || "";
        bValue = b[orderBy] || "";
      }

      // Handle date sorting
      if (orderBy === "createdDate" || orderBy === "updatedDate") {
        aValue = a[orderBy === "createdDate" ? "createdAt" : "updatedAt"];
        bValue = b[orderBy === "createdDate" ? "createdAt" : "updatedAt"];
        
        // Convert to timestamps for proper comparison
        aValue = aValue ? new Date(aValue).getTime() : 0;
        bValue = bValue ? new Date(bValue).getTime() : 0;
      }

      if (order === "asc") {
        return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
      } else {
        return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
      }
    });
  }, [rows, order, orderBy, searchKey.value]);

  const paginatedRows = useMemo(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return sortedRows.slice(startIndex, endIndex);
  }, [sortedRows, page, rowsPerPage]);

  const handleRequestSort = useCallback(
    (property) => {
      const isDesc = orderBy === property && order === "desc";
      const newOrder = isDesc ? "asc" : "desc";
      setOrder(newOrder);
      setOrderBy(property);
    },
    [orderBy, order]
  );

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  }, []);

  const handleChangePage = useCallback((event, newPage) => {
    setPage(newPage);
  }, []);

  const clearSearchText = useCallback(() => {
    setSearchKey({ value: "" });
    setPage(0);
  }, []);

  const handleSearch = useCallback((event) => {
    const value = event.target.value;
    setSearchKey({ value });
    setPage(0);
  }, []);

  return {
    rows,
    setRows,
    originalRows,
    setOriginalRows,
    paginatedRows,
    order,
    orderBy,
    page,
    rowsPerPage,
    searchKey,
    handleRequestSort,
    handleChangeRowsPerPage,
    handleChangePage,
    clearSearchText,
    handleSearch,
  };
};

/**
 * Individual client row component for the table
 * 
 * @param {Object} props - Component props
 * @param {Object} props.row - Client data row
 * @param {Function} props.onViewApiKey - Handler for viewing API key
 * @param {Function} props.onViewClient - Handler for viewing client details
 * @param {Function} props.onViewEmails - Handler for viewing client emails
 * @returns {JSX.Element} Client row component
 */
const ClientRow = React.memo(({ row, onViewApiKey, onViewClient, onViewEmails, classes }) => {
  // Get the most recent API key for status and user information
  const getLatestApiKeyInfo = (clientApiKeyArray) => {
    if (!Array.isArray(clientApiKeyArray) || clientApiKeyArray.length === 0) {
      return { isActive: false, createdBy: "", updatedBy: "" };
    }
    
    // Sort by createdAt to get the most recent
    const sortedKeys = [...clientApiKeyArray].sort((a, b) => {
      const dateA = new Date(a.createdAt || 0);
      const dateB = new Date(b.createdAt || 0);
      return dateB - dateA;
    });
    
    const latestKey = sortedKeys[0];
    return {
      isActive: latestKey.isActive || false,
      createdBy: latestKey.createdBy || "",
      updatedBy: latestKey.updatedBy || ""
    };
  };

  const apiKeyInfo = getLatestApiKeyInfo(row.clientApiKey);

  return (
    <TableRow className={classes.tableRow}>
      <TableCell
        align="center"
        className={classes.tableCell}
        style={{ width: "150px", minWidth: "150px", maxWidth: "150px" }}
      >
        {row.clientName || "N/A"}
      </TableCell>
      <TableCell
        align="center"
        className={classes.tableCell}
        style={{ width: "120px", minWidth: "120px", maxWidth: "120px" }}
      >
        {row.clientId || "N/A"}
      </TableCell>
      <TableCell 
        align="center" 
        className={classes.tableCellDescription}
        style={{ width: "200px", minWidth: "200px", maxWidth: "200px" }}
      >
        {row.clientDescription || "N/A"}
      </TableCell>
      <TableCell
        align="left"
        className={classes.tableCellStatus}
        style={{ width: "80px", minWidth: "80px", maxWidth: "80px" }}
      >
        <Chip
          label={apiKeyInfo.isActive ? "Active" : "Inactive"}
          color={apiKeyInfo.isActive ? "primary" : "default"}
          size="small"
        />
      </TableCell>
      <TableCell 
        align="center" 
        className={classes.tableCell}
        style={{ width: "120px", minWidth: "120px", maxWidth: "120px" }}
      >
        {formatDate(row.createdAt)}
      </TableCell>
      <TableCell 
        align="center" 
        className={classes.tableCell}
        style={{ width: "120px", minWidth: "120px", maxWidth: "120px" }}
      >
        {formatDate(row.updatedAt)}
      </TableCell>
      <TableCell 
        align="center" 
        className={classes.tableCellUser}
        style={{ width: "100px", minWidth: "100px", maxWidth: "100px" }}
      >
        {row.createdBy || "N/A"}
      </TableCell>
      <TableCell 
        align="center" 
        className={classes.tableCellUser}
        style={{ width: "100px", minWidth: "100px", maxWidth: "100px" }}
      >
        {row.updatedBy || "N/A"}
      </TableCell>
      <TableCell 
        align="center" 
        className={classes.tableCellActions}
        style={{ width: "120px", minWidth: "120px", maxWidth: "120px" }}
      >
        <Tooltip title="View Active API Key" placement="top">
          <IconButton onClick={() => onViewApiKey(row)} color="default">
            <VpnKeyIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Edit Client" placement="top">
          <IconButton onClick={() => onViewClient(row)} color="primary">
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="View Client Emails" placement="top">
          <IconButton onClick={() => onViewEmails(row)} color="primary">
            <EmailIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
});

/**
 * No data row component for empty table state
 * 
 * @param {Object} props - Component props
 * @param {number} props.colSpan - Number of columns to span
 * @param {boolean} props.backdrop - Whether backdrop is showing
 * @param {Object} props.classes - CSS classes
 * @returns {JSX.Element} No data row component
 */
const NoDataRow = React.memo(({ colSpan, backdrop, classes }) => (
  <TableRow className={classes.tableRow}>
    <TableCell
      colSpan={colSpan}
      align="center"
      className={classes.noRecordsRow}
    >
      {backdrop ? "Fetching data, please wait..." : "No clients found"}
    </TableCell>
  </TableRow>
));

/**
 * Create client form component
 * 
 * @param {Object} props - Component props
 * @returns {JSX.Element} Create client form component
 */
const CreateClientForm = React.memo(
  ({
    formData,
    emailError,
    nameError,
    descriptionError,
    error,
    errorMessage,
    onFieldChange,
    onSubmit,
    onClear,
    classes,
  }) => {
    const isFormValid = useMemo(() => {
      return (
        formData.clientName.value !== "" &&
        formData.clientDescription.value !== "" &&
        formData.clientEmails.value !== "" &&
        !emailError &&
        !nameError &&
        !descriptionError
      );
    }, [formData, emailError, nameError, descriptionError]);

    const canClear = useMemo(() => {
      return (
        formData.clientName.value !== "" ||
        formData.clientDescription.value !== "" ||
        formData.clientEmails.value !== ""
      );
    }, [formData]);

    return (
      <div className={classes.formContainer}>
        {/* Header */}
        <div className={`${classes.tableTitleDiv} ${classes.formHeader}`}>
          <div className={classes.tableTitle}>
            <h2>Create New Client</h2>
          </div>
        </div>
        
        <hr className={classes.horizontalLine} />
        
        {/* Two column layout */}
        <div className={classes.formTopRow}>
          <div className={classes.formLeftColumn}>
            <div className={classes.formField}>
              <TextField
                id="client-name"
                label="Client Name"
                variant="outlined"
                fullWidth
                required
                value={formData.clientName.value}
                onChange={(e) => onFieldChange("clientName", e.target.value)}
                error={nameError !== "" || (error && errorMessage.includes("already exists"))}
                helperText={
                  nameError || 
                  (error && errorMessage.includes("already exists")
                    ? "This client name is already taken"
                    : " ")
                }
                InputProps={{
                  style: { height: "56px" }
                }}
                FormHelperTextProps={{
                  style: { minHeight: "12px" }
                }}
              />
            </div>
            <div className={classes.formFieldDescription}>
              <TextField
                id="client-description"
                label="Client Description"
                variant="outlined"
                fullWidth
                required
                multiline
                rows={5}
                inputProps={{ maxLength: 500 }}
                value={formData.clientDescription.value}
                onChange={(e) =>
                  onFieldChange("clientDescription", e.target.value)
                }
                error={descriptionError !== ""}
                helperText={
                  descriptionError || 
                  `${formData.clientDescription.value.length}/500 characters`
                }
              />
            </div>
          </div>
          <div className={classes.formRightColumn}>
            <div className={classes.formFieldEmail}>
              <TextField
                id="client-emails"
                label="Client Emails"
                placeholder="email1@example.com, email2@example.com"
                variant="outlined"
                fullWidth
                required
                multiline
                rows={9}
                value={formData.clientEmails.value}
                onChange={(e) => onFieldChange("clientEmails", e.target.value)}
                error={!!emailError}
                helperText={
                  emailError ||
                  "Enter multiple emails separated by commas."
                }
                InputProps={{
                  style: { 
                    height: "auto",
                    minHeight: "224px"
                  }
                }}
              />
            </div>
          </div>
        </div>

        {/* Error message */}
        {error && (
          <div className={classes.errorContainer}>
            {errorMessage || "Error while creating client. Please try again."}
          </div>
        )}

        {/* Action buttons */}
        <div className={classes.formButtonContainer}>
          <Button
            color="primary"
            variant="contained"
            onClick={onSubmit}
            disabled={!isFormValid}
            style={{
              minWidth: "100px",
              height: "40px"
            }}
          >
            ADD
          </Button>
          <Button
            color="primary"
            variant="outlined"
            onClick={onClear}
            disabled={!canClear}
            style={{
              minWidth: "100px",
              height: "40px"
            }}
          >
            Clear
          </Button>
        </div>
      </div>
    );
  }
);

/**
 * Response table component for displaying client creation results
 * 
 * @param {Object} props - Component props
 * @param {Object} props.responseData - Response data to display
 * @param {Object} props.classes - CSS classes
 * @param {Function} props.onCopy - Copy handler function
 * @returns {JSX.Element} Response table component
 */
const ResponseTable = React.memo(({ responseData, classes, onCopy }) => (
  <Fragment>
    <div className={`${classes.tableTitleDiv2} ${classes.modalTitle}`}>
      <div className={classes.tableTitle}>
        <h2>Client Details</h2>
      </div>
      <Tooltip title="Copy client details to clipboard" placement="top">
        <IconButton
          onClick={onCopy}
          color="primary"
          style={{ marginRight: "20px" }}
        >
          <FileCopyIcon />
        </IconButton>
      </Tooltip>
    </div>
    <div className={classes.box}>
      <Table
        className={classes.tableProp}
        stickyHeader
        aria-label="sticky table"
      >
        <TableHead>
          <TableRow>
            {RESPONSE_COLUMNS.map((column) => (
              <TableCell
                width={column.width}
                key={column.id}
                align="center"
                className={classes.tableHeadRow}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {[
            "clientName",
            "clientId",
            "clientSecret",
            "clientApiKey",
            "clientEmails",
            "createdAt",
            "updatedAt",
          ]
            .filter((key) => responseData.hasOwnProperty(key))
            .map((key, index) => (
              <TableRow hover role="data-row" tabIndex={-1} key={index}>
                <TableCell align="center">
                  <strong>{key}</strong>
                </TableCell>
                <TableCell align="center">
                  {key === "clientEmails" && Array.isArray(responseData[key])
                    ? responseData[key].join(", ")
                    : key === "clientApiKey" && Array.isArray(responseData[key])
                    ? getActiveApiKey(responseData[key]) || "No active API key"
                    : key === "createdAt" || key === "updatedAt"
                    ? formatDate(responseData[key])
                    : responseData[key]}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </div>
  </Fragment>
));

/**
 * Email modal component for displaying client emails
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether modal is open
 * @param {Function} props.onClose - Close handler function
 * @param {Object} props.selectedClient - Selected client data
 * @returns {JSX.Element} Email modal component
 */
const EmailModal = React.memo(({ open, onClose, selectedClient, classes }) => {
  const copyEmails = (emails) => {
    if (emails && emails.length > 0) {
      const emailText = emails.join('\n');
      navigator.clipboard
        .writeText(emailText)
        .then(() => {
          notify({
            type: "success",
            message: "Emails copied to clipboard successfully!",
          });
        })
        .catch(() => {
          // Fallback for older browsers
          const textArea = document.createElement("textarea");
          textArea.value = emailText;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand("copy");
          document.body.removeChild(textArea);

          notify({
            type: "success",
            message: "Emails copied to clipboard successfully!",
          });
        });
    } else {
      notify({
        type: "error",
        message: "No emails available to copy.",
      });
    }
  };

  const emails = selectedClient ? (selectedClient.clientEmails || []) : [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <div className={classes.modalTitle}>
          <span>
            Client Emails: <strong className={classes.modalClientName}>
              {selectedClient && selectedClient.clientName}
            </strong>
          </span>
          <Tooltip title="Copy all emails to clipboard" placement="top">
            <IconButton
              onClick={() => copyEmails(emails)}
              color="primary"
              disabled={emails.length === 0}
            >
              <FileCopyIcon />
            </IconButton>
          </Tooltip>
        </div>
      </DialogTitle>
      <DialogContent>
        {emails.length > 0 ? (
          <div className={classes.modalContent}>
            <div className={classes.modalEmailContainer}>
              {emails.map((email, index) => (
                <Typography
                  key={index}
                  variant="body1"
                  className={index < emails.length - 1 ? classes.modalEmailText : classes.modalEmailTextLast}
                >
                  {email}
                </Typography>
              ))}
            </div>
          </div>
        ) : (
          <div className={classes.modalNoData}>
            <Typography variant="h6" gutterBottom>
              No Emails Found
            </Typography>
            <Typography variant="body2">
              This client does not have any emails configured.
            </Typography>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
});

/**
 * API key modal component for displaying all API keys
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether modal is open
 * @param {Function} props.onClose - Close handler function
 * @param {Object} props.selectedClient - Selected client data
 * @returns {JSX.Element} API key modal component
 */
const ApiKeyModal = React.memo(({ open, onClose, selectedClient, classes }) => {
  const copyApiKey = (apiKey) => {
    if (apiKey) {
      navigator.clipboard
        .writeText(apiKey)
        .then(() => {
          notify({
            type: "success",
            message: "API key copied to clipboard successfully!",
          });
        })
        .catch(() => {
          // Fallback for older browsers
          const textArea = document.createElement("textarea");
          textArea.value = apiKey;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand("copy");
          document.body.removeChild(textArea);

          notify({
            type: "success",
            message: "API key copied to clipboard successfully!",
          });
        });
    } else {
      notify({
        type: "error",
        message: "No API key available to copy.",
      });
    }
  };

  // Get sorted active API keys (latest first)
  const getActiveApiKeys = (clientApiKeyArray) => {
    if (!Array.isArray(clientApiKeyArray) || clientApiKeyArray.length === 0) {
      return [];
    }
    
    // Filter for active API keys only
    const activeApiKeys = clientApiKeyArray.filter(keyObj => {
      const isActive = keyObj.isActive !== undefined ? keyObj.isActive : true;
      return isActive;
    });
    
    // Sort by creation date (latest first)
    return activeApiKeys.sort((a, b) => {
      const dateA = new Date(a.createdAt || 0);
      const dateB = new Date(b.createdAt || 0);
      return dateB - dateA; // Descending order (latest first)
    });
  };

  const apiKeys = selectedClient ? getActiveApiKeys(selectedClient.clientApiKey) : [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        Active API Keys for Client: <strong className={classes.modalClientName}>
          {selectedClient && selectedClient.clientName}
        </strong>
      </DialogTitle>
      <DialogContent>
        {apiKeys.length > 0 ? (
          <div className={classes.modalContent}>
            {apiKeys.map((keyObj, index) => {
              const apiKey = keyObj.apiKey || keyObj;
              const isActive = keyObj.isActive !== undefined ? keyObj.isActive : true;
              const createdAt = keyObj.createdAt;
              const updatedAt = keyObj.updatedAt;
              const createdBy = keyObj.createdBy;
              const updatedBy = keyObj.updatedBy;

              return (
                <div key={index} className={classes.modalApiKeyContainer}>
                  <div style={{ flex: 1 }}>
                    <Typography variant="body2" className={classes.modalApiKeyText}>
                      <strong>API Key {index + 1}:</strong>{" "}
                      {apiKey}
                    </Typography>
                    <div>
                      {createdAt && (
                        <Typography variant="caption" className={classes.modalApiKeyInfo}>
                          Created:{" "}
                          {new Date(createdAt).toLocaleString()}
                        </Typography>
                      )}
                      {updatedAt && (
                        <Typography variant="caption" className={classes.modalApiKeyInfo}>
                          Updated:{" "}
                          {new Date(updatedAt).toLocaleString()}
                        </Typography>
                      )}
                      {createdBy && (
                        <Typography variant="caption" className={classes.modalApiKeyInfo}>
                          Created By:{" "}
                          {createdBy}
                        </Typography>
                      )}
                      {updatedBy && (
                        <Typography variant="caption" className={classes.modalApiKeyInfo}>
                          Updated By:{" "}
                          {updatedBy}
                        </Typography>
                      )}
                    </div>
                  </div>
                  <div className={classes.modalApiKeyActions}>
                    <Chip
                      label={isActive ? "Active" : "Inactive"}
                      color={isActive ? "primary" : "default"}
                      size="small"
                    />
                    <Tooltip title="Copy API Key" placement="top">
                      <IconButton
                        onClick={() => copyApiKey(apiKey)}
                        color="primary"
                        size="small"
                      >
                        <FileCopyIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className={classes.modalNoData}>
            <Typography variant="h6" gutterBottom>
              No Active API Keys Found
            </Typography>
            <Typography variant="body2">
              This client does not have any active API keys configured.
            </Typography>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
});
/**
 * ListClients Component
 * 
 * Provides a comprehensive interface for viewing, creating, and managing clients including:
 * - Client listing with search and pagination
 * - Client creation with validation
 * - API key management and viewing
 * - Client details navigation
 * 
 * @returns {JSX.Element} The ListClients component
 */
export default function ListClients() {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  // UI State
  const [backdrop, setBackdrop] = useState(false);
  const [showCreateClient, setShowCreateClient] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [apiKeyModalOpen, setApiKeyModalOpen] = useState(false);
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  
  // Data State
  const [responseData, setResponseData] = useState({});
  const [selectedClient, setSelectedClient] = useState(null);

  const {
    formData,
    emailError,
    nameError,
    descriptionError,
    error,
    errorMessage,
    updateField,
    clearForm,
    setErrors,
  } = useFormState();

  const {
    rows,
    setRows,
    originalRows,
    setOriginalRows,
    paginatedRows,
    order,
    orderBy,
    page,
    rowsPerPage,
    searchKey,
    handleRequestSort,
    handleChangeRowsPerPage,
    handleChangePage,
    clearSearchText,
    handleSearch,
  } = useTableState();

  /**
   * Fetches all clients from the API
   * Updates the table data and handles errors
   */
  const fetchClients = useCallback(async () => {
    setBackdrop(true);
    try {
      const response = await AdminDashboardService.viewClients();
      const clientsData = response.data || [];
      setRows(clientsData);
      setOriginalRows(clientsData);
      if (clientsData.length === 0) {
        notify({
          type: "info",
          message: "No clients found",
        });
      }
    } catch (error) {
      const errorMessage = getUserFriendlyErrorMessage(error);
      notify({
        type: "error",
        message: errorMessage,
      });
      console.error("Error fetching clients:", error);
      setRows([]);
    } finally {
      setBackdrop(false);
    }
  }, [setRows]);

  /**
   * Effect to handle page focus and refresh data
   */
  useEffect(() => {
    const handleFocus = () => {
      fetchClients();
    };

    // Refresh data when component mounts
    fetchClients();

    // Add event listener for when page comes into focus
    window.addEventListener('focus', handleFocus);
    
    // Cleanup
    return () => {
      window.removeEventListener('focus', handleFocus);
    };
  }, [fetchClients]);

  /**
   * Effect to refresh data when location changes
   */
  useEffect(() => {
    fetchClients();
  }, [location.pathname, fetchClients]);

  /**
   * Handles client creation with validation
   */
  const handleCreateClient = useCallback(async () => {
    const emailValidation = validateEmails(formData.clientEmails.value);
    if (!emailValidation.isValid) {
      notify({
        type: "error",
        message: "Please fix email validation errors before submitting",
      });
      return;
    }

    setBackdrop(true);
    setErrors(false, "");

    const clientData = {
      clientName: formData.clientName.value,
      clientDescription: formData.clientDescription.value,
    };

    if (formData.clientEmails.value.trim()) {
      const emailArray = formData.clientEmails.value
        .split(",")
        .map((email) => email.trim())
        .filter((email) => email !== "");
      clientData.clientEmails = emailArray;
    }

    try {
      const response = await AdminDashboardService.createClient(clientData);
      setShowTable(true);
      const responseWithClientName = {
        clientName: formData.clientName.value,
        clientEmails: clientData.clientEmails || [],
        ...response.data,
      };
      setResponseData(responseWithClientName);
      notify({
        type: "success",
        message: "Client created successfully! You can now view the client details below.",
      });
      fetchClients();
    } catch (error) {
      setShowTable(false);
      const errorMsg = getUserFriendlyErrorMessage(error);

      // Special handling for duplicate client name
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        if (
          errorData.errorCode === "40910" ||
          (errorData.message && errorData.message.includes("already exists"))
        ) {
          const duplicateErrorMsg = `A client named "${formData.clientName.value}" already exists. Please choose a different name.`;
          setErrors(true, duplicateErrorMsg);
          notify({
            type: "error",
            message: duplicateErrorMsg,
          });
          return;
        }
      }

      setErrors(true, errorMsg);
      notify({
        type: "error",
        message: errorMsg,
      });
    } finally {
      setBackdrop(false);
    }
  }, [formData, setErrors, fetchClients]);

  /**
   * Handles navigation to client details page
   */
  const handleViewClient = useCallback(
    (client) => {
      const clientWithActiveApiKey = {
        ...client,
        clientApiKey:
          getActiveApiKey(client.clientApiKey) || client.clientApiKey,
      };

      history.push({
        pathname: "/clientDetails",
        state: { client: clientWithActiveApiKey },
      });
    },
    [history]
  );

  /**
   * Handles viewing API key in modal
   */
  const handleViewApiKey = useCallback((client) => {
    const activeApiKey = getActiveApiKey(client.clientApiKey);
    const clientWithActiveApiKey = {
      ...client,
      activeApiKey: activeApiKey,
    };

    setSelectedClient(clientWithActiveApiKey);
    setApiKeyModalOpen(true);
  }, []);

  /**
   * Handles viewing client emails in modal
   */
  const handleViewEmails = useCallback((client) => {
    setSelectedClient(client);
    setEmailModalOpen(true);
  }, []);

  /**
   * Toggles the create client form visibility
   */
  const toggleCreateClient = useCallback(() => {
    setShowCreateClient((prev) => {
      if (prev) {
        clearForm();
        setShowTable(false);
        setResponseData({});
      }
      return !prev;
    });
  }, [clearForm]);

  /**
   * Clears the form and resets related state
   */
  const handleClearForm = useCallback(() => {
    clearForm();
    setResponseData({});
    setShowTable(false);
  }, [clearForm]);

  /**
   * Copies table data to clipboard
   */
  const copyTableData = useCallback(() => {
    try {
      let copyText = "Client Details:\n\n";
      Object.keys(responseData).forEach((key) => {
        if (key === "clientEmails" && Array.isArray(responseData[key])) {
          copyText += `${key}: ${responseData[key].join(", ")}\n`;
        } else if (key === "clientApiKey" && Array.isArray(responseData[key])) {
          const activeKey = getActiveApiKey(responseData[key]);
          copyText += `${key}: ${activeKey || "No active API key"}\n`;
        } else {
          copyText += `${key}: ${responseData[key]}\n`;
        }
      });

      navigator.clipboard
        .writeText(copyText)
        .then(() => {
          notify({
            type: "success",
            message: "Client details copied to clipboard successfully!",
          });
        })
        .catch(() => {
          const textArea = document.createElement("textarea");
          textArea.value = copyText;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand("copy");
          document.body.removeChild(textArea);

          notify({
            type: "success",
            message: "Client details copied to clipboard successfully!",
          });
        });
    } catch (error) {
      notify({
        type: "error",
        message: "Unable to copy client details to clipboard. Please try again.",
      });
    }
  }, [responseData]);

  return (
    <div className={classes.borderMain}>
      <Backdrop open={backdrop} style={{ color: "primary", zIndex: 1000000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Paper className={classes.root}>
        <Grid item xs={12} className={classes.gridItem}>
          {/* Header */}
          <div className={`${classes.tableTitleDiv} ${classes.modalTitle}`}>
            <div className={classes.tableTitle}>
              <h2>View Clients</h2>
            </div>
            <Button
              variant="contained"
              color="primary"
              startIcon={showCreateClient ? <ExpandLessIcon /> : <AddIcon />}
              onClick={toggleCreateClient}
              className={classes.submitFilterButton}
            >
              {showCreateClient ? "Hide Create Client" : "Create Client"}
            </Button>
          </div>

          {/* Create Client Section */}
          <Collapse in={showCreateClient}>
            <CreateClientForm
              formData={formData}
              emailError={emailError}
              nameError={nameError}
              descriptionError={descriptionError}
              error={error}
              errorMessage={errorMessage}
              onFieldChange={updateField}
              onSubmit={handleCreateClient}
              onClear={handleClearForm}
              classes={classes}
            />

            {showTable && (
              <ResponseTable
                responseData={responseData}
                classes={classes}
                onCopy={copyTableData}
              />
            )}
          </Collapse>

          {/* Clients List Table */}
          <div className={classes.transactionListDiv}>
            {/* Search Box */}
            <div className={classes.searchContainer}>
              <div className={classes.searchBox}>
                <InputBase
                  onChange={handleSearch}
                  value={searchKey.value}
                  className={classes.searchInput}
                  placeholder="Search Client"
                />
                {searchKey.value.length ? (
                  <IconButton
                    size="medium"
                    aria-label="clear search"
                    onClick={clearSearchText}
                  >
                    <CloseIcon />
                  </IconButton>
                ) : (
                  ""
                )}
                <IconButton
                  size="medium"
                  aria-label="search"
                  disabled
                >
                  <SearchIcon />
                </IconButton>
              </div>
            </div>

            <div className={`${classes.tableWrapper} ${classes.tableWrapperContainer}`}>
              <Paper className={classes.tableContainer}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  className={classes.tableBorder}
                  style={{ tableLayout: "fixed" }}
                >
                  <TableHead>
                    <TableRow>
                      {TABLE_COLUMNS.map((column) => {
                        // Custom alignment for specific columns
                        const isLeftAligned = column.id === "isActiveStatus";
                        const isRightShifted = column.id === "createdBy" || column.id === "updatedBy";
                        
                        return (
                          <TableCell
                            width={column.width}
                            key={column.id}
                            align={isLeftAligned ? "left" : "center"}
                            sortDirection={orderBy === column.id ? order : false}
                            className={`${classes.tableHeadRow} ${isLeftAligned ? classes.tableHeaderCellLeft : classes.tableHeaderCell}`}
                            style={{ 
                              width: column.width,
                              minWidth: column.width,
                              maxWidth: column.width
                            }}
                          >
                            {column.sortable ? (
                              <TableSortLabel
                                className={isLeftAligned ? classes.tableSortLabelLeft : classes.tableSortLabel}
                                active={orderBy === column.id}
                                direction={orderBy === column.id ? order : "asc"}
                                onClick={() => handleRequestSort(column.id)}
                                style={{ 
                                  paddingLeft: isRightShifted ? "15px" : "0px"
                                }}
                              >
                                {column.label}
                                {orderBy === column.id && (
                                  <span className={classes.visuallyHidden}>
                                    {order === "desc"
                                      ? "sorted descending"
                                      : "sorted ascending"}
                                  </span>
                                )}
                              </TableSortLabel>
                            ) : (
                              <div className={isRightShifted ? classes.tableHeaderTextShifted : (isLeftAligned ? classes.tableHeaderTextLeft : classes.tableHeaderText)}>
                                {column.label}
                              </div>
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.length ? (
                      paginatedRows.map((row, index) => (
                        <ClientRow
                          key={`${row.clientId}-${index}`}
                          row={row}
                          onViewApiKey={handleViewApiKey}
                          onViewClient={handleViewClient}
                          onViewEmails={handleViewEmails}
                          classes={classes}
                        />
                      ))
                    ) : (
                      <NoDataRow
                        colSpan={TABLE_COLUMNS.length}
                        backdrop={backdrop}
                        classes={classes}
                      />
                    )}
                  </TableBody>
                </Table>
              </Paper>
            </div>

            {rows.length > 0 && (
              <TablePagination
                rowsPerPageOptions={USER_PREFERENCES.rowsPerPageOptions}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                backIconButtonProps={{ "aria-label": "previous page" }}
                nextIconButtonProps={{ "aria-label": "next page" }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage="Rows per page"
              />
            )}
          </div>
        </Grid>
      </Paper>

      {/* API Key Modal */}
      <ApiKeyModal
        open={apiKeyModalOpen}
        onClose={() => setApiKeyModalOpen(false)}
        selectedClient={selectedClient}
        classes={classes}
      />

      {/* Email Modal */}
      <EmailModal
        open={emailModalOpen}
        onClose={() => setEmailModalOpen(false)}
        selectedClient={selectedClient}
        classes={classes}
      />
    </div>
  );
}
